// extracted by mini-css-extract-plugin
module.exports = {"sider":"sider-RfiIMCdu"};